export const TESTIMONIALS = [
  {
    quote:
      'Aurelia has completely changed how I manage my health. Their team is exceptional — punctual, warm, and remarkably discreet. It feels like having a private medical concierge on call.',
    name: 'Alexandra M.',
    title: 'Founder & CEO',
    location: 'Buckhead, Atlanta',
  },
  {
    quote:
      'The convenience is unmatched. I have my quarterly panels drawn at my office in fifteen minutes, and results are back before the day ends. Truly white-glove service.',
    name: 'Dr. Julian R.',
    title: 'Managing Partner',
    location: 'Midtown Atlanta',
  },
  {
    quote:
      'We hired Aurelia for a company-wide wellness day and the feedback from our team was extraordinary. Professional, seamless, and elevated from start to finish.',
    name: 'Priya S.',
    title: 'Chief People Officer',
    location: 'Sandy Springs',
  },
  {
    quote:
      'As someone with young children, having lab work done at home has been a gift. The phlebotomist was gentle, kind, and turned what is usually a stressful experience into an easy one.',
    name: 'Marcus & Elena T.',
    title: 'Private Clients',
    location: 'Brookhaven',
  },
  {
    quote:
      'Their BLS training was the most engaging certification course our clinical staff has ever attended. Rigorous, thoughtful, and tailored to how we actually work.',
    name: 'Renee A., RN',
    title: 'Director of Nursing',
    location: 'Alpharetta',
  },
  {
    quote:
      'Discreet is the word. Every appointment feels considered — from the way they arrive, to the care they take, to the follow-through. This is what modern healthcare should feel like.',
    name: 'Thomas W.',
    title: 'Executive Client',
    location: 'Vinings',
  },
];
